import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Modal } from '../../models/modal.model';

@Component({
standalone: false,
  selector: 'app-modal',
  styleUrls: ['./modal.component.scss'],
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Modal,
    private dialogRef: MatDialogRef<ModalComponent>,
    private router: Router,
  ) {}

  public onClickActionButton(actionButtonUrl: string): void {
    this.router.navigate([actionButtonUrl]).finally(() => this.dialogRef.close());
  }
}
